import { forwardRef, Ref } from 'react';

import { Box, BoxProps } from '../../../Box/Box';
import { Hint } from '../../../Hint/Hint';
import { Field, FieldProps } from '../../../Field/Field';

type Props = {
  visuallyHiddenHint: string;
  hint: string;
  styles: BoxProps['styles'];
} & FieldProps;

function FieldWithHint(
  { visuallyHiddenHint, hint, styles, disabled, ...fieldProps }: Props,
  ref: Ref<HTMLInputElement>
) {
  return (
    <Box
      as="label"
      display="flex"
      flexDirection="column"
      flexShrink={0}
      styles={{
        ...styles,
        pointerEvents: disabled ? 'none' : 'all',
      }}
    >
      <Box as={Hint} mb="datepickerHintMarginBottom">
        {hint}
      </Box>
      <Field
        {...fieldProps}
        aria-placeholder={visuallyHiddenHint}
        ref={ref}
        aria-autocomplete="none"
        autoComplete="off"
        inputMode="numeric"
        style={{
          textOverflow: 'ellipsis',
          fontFeatureSettings: '"tnum"',
        }}
        disabled={disabled}
      />
    </Box>
  );
}

export default forwardRef(FieldWithHint);
